interface PageLoaderProps {}

const PageLoader = ({}: PageLoaderProps) => {
  return (
    <div className="h-svh w-full flex justify-center items-center z-[272387424232]">
      <div className="relative w-48 h-34 animate-pulse">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 160 160"
          className="w-full h-full"
        >
          {/* Static text - centered */}
          <text
            x="80"
            y="87"
            textAnchor="middle"
            fontFamily="Arial, sans-serif"
            fontSize="24"
            fontWeight="bold"
          >
            <tspan fill="#1A365D" className="dark:fill-gray-100">
              nett
            </tspan>
            <tspan fill="#3182CE" className="dark:fill-[#63B3ED]">
              pay
            </tspan>
          </text>

          {/* Animated circle */}
          <circle
            cx="80"
            cy="80"
            r="60"
            stroke="#3182CE"
            className="dark:stroke-[#63B3ED]"
            strokeWidth="4"
            strokeDasharray="377"
            strokeDashoffset="377"
            fill="none"
          >
            <animate
              attributeName="stroke-dashoffset"
              from="377"
              to="0"
              dur="2s"
              repeatCount="indefinite"
            />
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 80 80"
              to="360 80 80"
              dur="2s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
    </div>
  );
};
export default PageLoader;
